<!-- BEGIN login -->
<div class="login">
    <!-- BEGIN login-content -->
    <div class="login-content">
        <div class="text-center">
            <div class="login-logo account-small-logo"></div>
        </div>
        <br/>
        <br/>
        <br/>
        <br/>
        <form>
            <h1 class="text-center">You've been logged out!</h1>
            <div class="text text-opacity-50 text-center mb-4">
            </div>
            <button type="submit" (click)="loginAzure()" class="btn btn-outline-theme btn-lg d-block w-100 fw-500 mb-3">Login with Azure</button>
        </form>
    </div>
    <!-- END login-content -->
</div>
<!-- END login -->
